import React, { Component } from 'react'
import CityCouncilPage from '../../components/CityCouncilPage'
import cityCouncilReport from '../../data/toronto/cityCouncil.json'

class TorontoCityCouncil extends Component<void> {
  render() {
    return (
      <CityCouncilPage
        name='Toronto'
        region='Ontario'
        {...cityCouncilReport}
      />
    )
  }
}

export default TorontoCityCouncil



// WEBPACK FOOTER //
// ./src/containers/TorontoCityCouncil/TorontoCityCouncil.js